import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import TabSlider from './TabSlider';

import './main-template.scss';

class ArrowButton extends PureComponent {
  render() {
    return (
      <button
        type="button"
        className={this.props.className}
        onClick={this.props.onClick}
      />
    );
  }
}

ArrowButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

class MainTemplate extends PureComponent {
  render() {
    const activeTab = this.props.tabs[this.props.activeIndex];

    return (
      <div className="main full-height-container">
        <Helmet>
          <title>{activeTab.meta.title}</title>
        </Helmet>

        {(!this.props.isMobile) &&
          <ArrowButton
            className="slick-arrow slick-next"
            onClick={this.props.onNextClick}
          />
        }

        <TabSlider
          tabs={this.props.tabs}
          activeIndex={this.props.activeIndex}
          forceIndex={this.props.forceIndex}
          isMobile={this.props.isMobile}
          onSlide={this.props.onSlide}
        />

        {(!this.props.isMobile) &&
          <ArrowButton
            className="slick-arrow slick-prev"
            onClick={this.props.onPrevClick}
          />
        }
      </div>
    );
  }
}

MainTemplate.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  nextIndex: PropTypes.number.isRequired,
  forceIndex: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      pathname: PropTypes.string,
      button: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      background: PropTypes.string,
      parallax: PropTypes.arrayOf(PropTypes.string),
      links: PropTypes.arrayOf(PropTypes.object),
      meta: PropTypes.object
    })
  ).isRequired,
  isMobile: PropTypes.bool.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onSlide: PropTypes.func.isRequired
};

export default MainTemplate;



// WEBPACK FOOTER //
// ./src/components/Main/MainTemplate.js